import type { Locale } from '@backmarket/http-api'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'

import { COOKIE_LANGUAGE } from '../constants'

import { replaceLocaleInPath } from './replaceLocaleInPath'

type ChangeLanguageOptions = {
  shouldUpdatePath?: boolean
}

export function changeLanguage(
  locale: Locale,
  options?: ChangeLanguageOptions,
) {
  const { shouldUpdatePath = false } = options ?? {}

  setBrowserCookie(COOKIE_LANGUAGE, locale, { path: '/' })

  if (shouldUpdatePath) {
    const url = new URL(window.location.href)
    url.pathname = replaceLocaleInPath(url.pathname, locale)
    window.location.href = url.toString()
  } else {
    window.location.reload()
  }
}
